import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChildService } from "../../services/child.service";
import styles from "../../pages/css/Children.module.css";
import { baseURL } from "../../services/axios";
import { useRefreshOnPurchase } from "../../hooks/usePurchaseSuccess";

type Child = {
  code: number
  id: string;
  lname: string;
  fname: string;
  birthday: string;
  educationalInstitution: string;
};

/**
 * קומפוננטת טבלת ילדים - מציגה רשימת ילדים עם חיפוש לפי שם מלא (פרטי או משפחה בכל סדר)
 */
export const ChildrenTable = ({ analystCode }: { analystCode: number }) => {
  const [children, setChildren] = useState<any[]>([]);
  const [filteredChildren, setFilteredChildren] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  const fetchChildren = async () => {
    try {
      const data = await ChildService.getByAnalystId(analystCode);
      setChildren(data);
      setFilteredChildren(data);
    } catch (error) {
      console.error("Failed to fetch children:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (analystCode) fetchChildren();
  }, [analystCode]);

  // ✅ אוטומטית רענן את רשימת הילדים כשיש רכישה מוצלחת
  useRefreshOnPurchase(fetchChildren);

  useEffect(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    const filtered = children.filter((child) => {
      const fullName1 = `${child.fname} ${child.lname}`.toLowerCase();
      const fullName2 = `${child.lname} ${child.fname}`.toLowerCase();

      return (
        fullName1.includes(normalizedSearch) ||
        fullName2.includes(normalizedSearch)
      );
    });


    setFilteredChildren(filtered);
  }, [searchTerm, children]);

  // const calculateAge = (birthday: string) => {
  //   const birthDate = new Date(birthday);
  //   const now = new Date();
  //   let age = now.getFullYear() - birthDate.getFullYear();
  //   const monthDiff = now.getMonth() - birthDate.getMonth();
  //   if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
  //     age--;
  //   }
  //   return age;
  // };
const calculateAge = (birthday: string) => {
  const birthDate = new Date(birthday);

  // ננקה את השעות כך שנשווה רק לפי תאריך
  const birthYear = birthDate.getUTCFullYear();
  const birthMonth = birthDate.getUTCMonth();
  const birthDay = birthDate.getUTCDate();

  const today = new Date();
  const currentYear = today.getUTCFullYear();
  const currentMonth = today.getUTCMonth();
  const currentDay = today.getUTCDate();

  let age = currentYear - birthYear;

  if (
    currentMonth < birthMonth ||
    (currentMonth === birthMonth && currentDay < birthDay)
  ) {
    age--;
  }

  return age;
};

  if (loading) return <p className={styles.note}>טוען נתונים...</p>;
  if (children.length === 0) return <p className={styles.note}>לא נמצאו ילדים</p>;

  return (
    <div>
      <div className={styles.searchWrapper}>
        <input
          type="text"
          placeholder="חיפוש לפי שם..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>שם מלא</th>
            <th>גיל</th>
            <th>ת.ז</th>
          </tr>
        </thead>
<tbody>
  {filteredChildren.map((child) => {
    console.log(child); // כאן נבדוק מה מגיע מהשרת

    return (
      <tr
        key={child.id}
        onClick={() => navigate(`/analystArea/children/childDetails/${child.id}`)}
        className={styles.tableRow}
      >
        <td>{`${child.name}`}</td>
        <td>{calculateAge(child.birthday)}</td>
        <td>{child.idNumber}</td>
      </tr>
    );
  })}
</tbody>
      </table>
    </div>
  );
};
